module.exports = __webpack_public_path__ + "24516554c8b869aa2af5dd5d9ccfad83.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C000006ZW.png
// module id = 1514
// module chunks = 0